import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnChanges,
  Pipe,
  PipeTransform,
  SimpleChanges,
} from '@angular/core';
import { I18NEXT_SERVICE, I18NextModule, ITranslationService } from 'angular-i18next';
import { BaseComponent } from '../base/base.component';

import { NgClass } from '@angular/common';
import { EllipsisTooltipDirective } from '../../../common/ellipsis-tooltip/ellipsis-tooltip.directive';
import { RouterLink } from '@angular/router';
import { RouteTranslatePipe } from '../../pipes/route-translate.pipe';
import { OpenDialogService } from '../../../common/open-dialog/open-dialog.service';

@Pipe({
  name: 'repeat',
  standalone: true,
})
export class RepeatPipe implements PipeTransform {
  transform(value: string, repeatCount: number): string {
    let s = value;
    for (let i = 0; i < repeatCount; i++) {
      s += value;
    }
    return s;
  }
}

@Component({
  selector: 'sharry-cherry-box',
  templateUrl: './cherry-box.component.html',
  styleUrls: ['./cherry-box.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, I18NextModule, RepeatPipe, EllipsisTooltipDirective, RouterLink, RouteTranslatePipe],
})
export class CherryBoxComponent extends BaseComponent implements OnChanges {
  @Input() __typename: 'Sharry' | 'Wonder' | 'Event' | 'User';
  @Input() myCherries = false;
  @Input() username: string;
  @Input() totalCherries = 0;

  _type: string;
  _cherries: number[] = [0, 0, 0, 0, 0];
  math = Math;

  constructor(
    @Inject(I18NEXT_SERVICE) private translateService: ITranslationService,
    private openDialogService: OpenDialogService,
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.totalCherries?.currentValue) {
      this._cherries = Intl.NumberFormat('it-IT', { minimumIntegerDigits: 5, useGrouping: false })
        .format(changes?.totalCherries?.currentValue)
        .split('')
        .map(n => Number(n));
    }
    if (changes?.__typename?.currentValue) {
      this._type =
        changes.__typename.currentValue === 'Event'
          ? `questo ${this.translateService.t(changes.__typename.currentValue.toLowerCase())}`
          : `questa ${this.translateService.t(changes.__typename.currentValue.toLowerCase())}`;
    }
  }

  onOpenModalCherryMeter() {
    import('../../../_shared/dialogs/cherry-meter-dialog/cherry-meter-dialog.component').then(
      ({ CherryMeterDialogComponent }) =>
        this.openDialogService.openDialog(CherryMeterDialogComponent, {
          ...{
            autoFocus: false,
            restoreFocus: false,
            minWidth: '50vw',
            maxHeight: '84vh',
          },
        }),
    );
  }
}
